import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-videos-large.tsx
/**
* icon.24.videos.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE4LjIwNCA4LjAxQTIgMiAwIDAgMSAyMCAxMHY4bC0uMDEuMjA0YTIgMiAwIDAgMS0xLjc4NiAxLjc4NUwxOCAyMGgtOGEyIDIgMCAwIDEtMS45OS0xLjc5Nkw4IDE4di04YTIgMiAwIDAgMSAyLTJoOHpNMTAgOWExIDEgMCAwIDAtMSAxdjhhMSAxIDAgMCAwIDEgMWg4YTEgMSAwIDAgMCAxLTF2LThhMSAxIDAgMCAwLTEtMXptMS45OTggMi4xMzVhMSAxIDAgMCAxIC45OTgtLjAwM2wzLjUgMmExIDEgMCAwIDEgMCAxLjczNmwtMy41IDJBMSAxIDAgMCAxIDExLjUgMTZ2LTRhMSAxIDAgMCAxIC40OTgtLjg2NW0yLjIwNi03LjEyNEEyIDIgMCAwIDEgMTYgNnYuNWEuNS41IDAgMCAxLTEgMFY2YTEgMSAwIDAgMC0xLTFINmExIDEgMCAwIDAtMSAxdjhhMSAxIDAgMCAwIDEgMWguNWEuNS41IDAgMCAxIDAgMUg2YTIgMiAwIDAgMS0xLjk5LTEuNzk2TDQgMTRWNmEyIDIgMCAwIDEgMi0yaDh6TTEyLjUgMTZsMy41LTItMy41LTJ6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=24953-59869
*/
const Icon24VideosLarge = memo(function Icon24VideosLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M18.204 8.01A2 2 0 0 1 20 10v8l-.01.204a2 2 0 0 1-1.786 1.785L18 20h-8a2 2 0 0 1-1.99-1.796L8 18v-8a2 2 0 0 1 2-2h8zM10 9a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zm1.998 2.135a1 1 0 0 1 .998-.003l3.5 2a1 1 0 0 1 0 1.736l-3.5 2A1 1 0 0 1 11.5 16v-4a1 1 0 0 1 .498-.865m2.206-7.124A2 2 0 0 1 16 6v.5a.5.5 0 0 1-1 0V6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h.5a.5.5 0 0 1 0 1H6a2 2 0 0 1-1.99-1.796L4 14V6a2 2 0 0 1 2-2h8zM12.5 16l3.5-2-3.5-2z"
		})
	});
});
//#endregion
export { Icon24VideosLarge };

//# sourceMappingURL=icon-24-videos-large.js.map